/* eslint-disable */
export default {
  notActivated: 'Inactivo',
} as const;

// @key: @#@"notActivated"@#@ @source: @#@"Inactive"@#@
